import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Breadcrumb, Form, Tab, Tabs } from 'react-bootstrap';
import InfoTab from './info/InfoTab';
import GeneralTab from './general/GeneralTab';
import TechnicalDataTab from './technicalData/TechnicalDataTab';
import { createWorkOrderAsync, deleteWorkOrderByIdAsync, getAllWorkOrderStatusAsync, getContactPersonsByIdAsync, getWorkOrderByIdAsync, updateModulePermissionsStatusAsync, updateWorkOrderAsync, updateWorkOrderStatusById } from '@application/features/workorders/workorderThunk';
import VnButton from '@ui/components/VnButton';
import { copyOutline, saveOutline, trashOutline, printOutline, add, receiptOutline, bagHandleOutline } from 'ionicons/icons';
import './style.css';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useNavigate, useParams } from 'react-router-dom';
import HoursandMaterialsTab from './hoursAndMaterial/HoursandMaterialsTab';
import CalculationTab from './calculation/CalculationTab';
import OrdersTab from './order/OrdersTab';
import NotesTab from './note/NotesTab';
import AttachmentsTab from './attachment/AttachmentsTab';
import Select from 'react-select';
import { statusDropDownStyles } from '@ui/styles/status-dropdown-style';
import ModalPopup from '@ui/components/VnModal';
import TerplaatsForm from '../printWorkOrderForms/TerplaatsForm';
import PompForm from '../printWorkOrderForms/PompForm';
import VentilatorForm from '../printWorkOrderForms/VentilatorForm';
import StandardForm from '../printWorkOrderForms/StandardForm';
import { setWorkOrderNumber } from '@application/features/quotations/quotationSlice';
import { setWorkOrderNumberAtOrder } from '@application/features/orders/orderSlice';
import { WorkorderCategory } from '@application/common/enums/workorder-category';
import { WorkorderStatus } from '@application/common/enums/workorder-status';
import WorkOrderTabsHelpers from './WorkOrderHelpers';
import { IonIcon } from '@ionic/react';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import VnNotificationModel from '@ui/components/VnNotificationModel';
import DeliveryNoteHoursAndMaterialTable from '../DeliveryNoteHoursAndMaterialTable';
import { setInvoiceWorkOrderNumber } from '@application/features/invoices/invoiceSlice';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import SealForm from '../printWorkOrderForms/SealForm';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
import { CalculationSelectionTable } from '../CalculationSelectionTable';
import { CalculationSelectionForOrderTable } from '../CalculationSelectionForOrderTable';
import MotorReductorForm from '../printWorkOrderForms/MotorReductorForm';
import MotorForm from '../printWorkOrderForms/MotorForm';
import { TabNotification } from '@ui/components/VnTabNotification';
import { VisserModule } from '@application/common/enums/visser-module';
import PersistentWarningMessage from '@ui/components/VnNotification/PersistantWarningMessage';
import PersistentInfoMessage from '@ui/components/VnNotification/PersistantInfoMessage';
import { clearUpdateModulePermissionStatus, resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
import { useAsyncDebounce } from '@application/common/hooks/use-async-debounce';
import { getAllQuotationAmountsAsync } from '@application/features/quotations/quotationThunk';
import { addErrorNotification } from '@application/features/common/notificationSlice';
import WorkorderLabelPreview from './print/WorkorderLabelPreview';
const WorkorderView = () => {
    // const warningMessageRef = useRef<{ resetTimer: () => void } | null>(null);
    const { handleFieldChange, handleCalendarChange, handleToggelButtonChange, handleTimeCalendarChange, handleContactUpdate, validateForm, formData, setFormData, errors, infoTabErrorBorderColor, generalTabErrorBorderColor, technicalTabErrorBorderColor, isNotitiesTabUnsaved, isTechnicalTabUnsaved, isGeneralTabUnsaved, isInfoTabUnsaved, isInfoTabBold, isGeneralTabBold, isTechnicalDataTabBold, isNotesTabBold } = WorkOrderTabsHelpers();
    // ---------
    const [isWorkOrderPrintPreviewPopupOpen, setIsWorkOrderPrintPreviewPopupOpen] = useState(false);
    const handlePrintNode = async () => {
        setIsWorkOrderPrintPreviewPopupOpen(true);
    };
    //-------------------------------
    const { materials } = useAppSelector((state) => state.material);
    const handleFieldChangeWrapper = async (fieldName, value) => {
        var moduleLockStatus = await checkModulelockandTimeTriggerForFields();
        if (moduleLockStatus == false) {
            handleFieldChange(fieldName, value); // Call the original handleFieldChange
        }
    };
    const handleFieldChangeWrapperForText = async (fieldName, value) => {
        handleFieldChange(fieldName, value); // Call the original handleFieldChange
        var moduleLockStatus = await checkModulelockandTimeTriggerForFields();
        // if (moduleLockStatus == false) {
        //     handleFieldChange(fieldName, value); // Call the original handleFieldChange
        // }
    };
    const handleCalendarChangeWrapper = async (fieldName, value) => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            handleCalendarChange(fieldName, value); // Call the original handleFieldChange
        }
    };
    const handleToggelButtonChangeWrapper = async (fieldName, value) => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            handleToggelButtonChange(fieldName, value); // Call the original handleFieldChange
        }
    };
    const handleTimeCalendarChangeWrapper = async (fieldName, value) => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            handleTimeCalendarChange(fieldName, value); // Call the original handleFieldChange
        }
    };
    const handleContactUpdateWrapper = async (workOrderContacts, index) => {
        var moduleLockStatus = await checkModulelockandTimeTriggerForFields();
        if (moduleLockStatus == false) {
            handleContactUpdate(workOrderContacts, index); // Call the original handleFieldChange
        }
    };
    const handleTabChange = (tabKey) => {
        if (tabKey) {
            setActiveTab(tabKey);
        }
    };
    const handleStatusDropdownChange = (selectedOption) => {
        setFormData((prevData) => ({
            ...prevData,
            statusId: selectedOption.value
        }));
    };
    //------------------------------------
    const onWorkOrderStatusChange = () => {
        if (formData.workCategoryId == WorkorderCategory.Levering || formData.workCategoryId == WorkorderCategory.Levering_ipv_reparatie) {
            return;
        }
        dispatch(updateWorkOrderStatusById({
            workOrderId: parseInt(id),
            statusId: WorkorderStatus.Monteur_Diagnose_stellen
        })).then(() => {
            setFormData((prevData) => ({
                ...prevData,
                statusId: WorkorderStatus.Monteur_Diagnose_stellen
            }));
        });
    };
    //-------------------------------------------
    const dispatch = useAppDispatch();
    const { workOrderStatusDropdown, moduleLocked, updateModulePermissionStatus } = useAppSelector((state) => state.workorder);
    const { currentUser } = useAppSelector((state) => state.auth);
    const [activeTab, setActiveTab] = useState('InfoTab');
    const [submitWorkOrder, setSubmitWorkOrder] = useState(false);
    const [isWorkOrderDeleteConfirmationPopup, setWorkOrderDeleteConfirmationPopup] = useState(false);
    const [isWorkOrderDeleteNotificationPopup, setWorkOrderDeleteNotificationPopup] = useState(false);
    const [workOrderDeleteErrorMessage, setWorkOrderDeleteErrorMessage] = useState('');
    const [isDeliveryNoteTableOpen, setIsDeliveryNoteTableOpen] = useState(false);
    const [disableWorkOrder, setDisableWorkOrder] = useState(false);
    const [deliveryNoteWorkOrderData, setDeliveryNoteWorkOrderData] = useState(formData);
    const [copyPopupOpen, IsCopyPopupOpen] = useState(false);
    const [savedDebtor, setSavedDebtor] = useState('');
    const [savedDescription, setSavedDescription] = useState('');
    const [isCalculationSelectionTableOpen, setIsCalculationSelectionTableOpen] = useState(false);
    const [isCalculationSelectionForOrderTableOpen, setIsCalculationSelectionForOrderTableOpen] = useState(false);
    // const [isMaterialSelectionTableOpen, setIsMaterialSelectionTableOpen] = useState(false);
    const [isPersistantInfoCustomToasterOpen, setIsPersistantInfoCustomToasterOpen] = useState(false);
    const [isHoursAndMaterialTabBold, setIsHoursAndMaterialTabBold] = useState(false);
    const [isCalculationTabBold, setIsCalculationTabBold] = useState(false);
    const [isOrderTabBold, setIsOrderTabBold] = useState(false);
    const [isAttachmentTabBold, setIsAttachmentTabBold] = useState(false);
    const [isQuotationWarningMessagePopupOpen, setIsQuotationWarningMessagePopupOpen] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();
    VnDocumentTitle('Visser Wer-' + formData.workOrderNumber);
    useEffect(() => {
        dispatch(getAllWorkOrderStatusAsync());
        if (id) {
            dispatch(getWorkOrderByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setFormData(res);
                setDeliveryNoteWorkOrderData(res);
                if (res.statusId == WorkorderStatus.Gefactureerd || res.statusId == WorkorderStatus.Vervallen) {
                    setDisableWorkOrder(true);
                }
            })
                .catch((error) => {
                navigate(`/admin/WorkOrdersList`);
                console.error('Bad request.');
            });
        }
    }, [dispatch, id]);
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (submitWorkOrder) {
            var moduleLockStatus = await checkModulelock();
            if (moduleLockStatus == false) {
                const triggeredErrors = validateForm();
                if (Object.values(triggeredErrors).every((error) => error === '' || error?.length === 0)) {
                    if (id) {
                        dispatch(updateWorkOrderAsync(formData))
                            .unwrap()
                            .then((res) => {
                            dispatch(getWorkOrderByIdAsync(res.id))
                                .unwrap()
                                .then((reply) => {
                                setFormData(reply);
                                setDeliveryNoteWorkOrderData(reply);
                                if (reply.statusId == WorkorderStatus.Gefactureerd || reply.statusId == WorkorderStatus.Vervallen) {
                                    setDisableWorkOrder(true);
                                }
                                dispatch(getContactPersonsByIdAsync(res.debtorId));
                            });
                        })
                            .catch((error) => {
                            console.error('Error updating work order');
                        });
                    }
                    else {
                        formData.statusId = WorkorderStatus.Nieuw;
                        dispatch(createWorkOrderAsync(formData))
                            .unwrap()
                            .then((res) => navigate(`/admin/WorkordersTabs/${res.id}`))
                            .catch((error) => {
                            console.error('Error creating work order');
                        });
                    }
                }
            }
            setSubmitWorkOrder(false);
        }
    };
    const [isPrintFormOpen, SetisPrintFormOpen] = useState(false);
    function oncloseClicked() {
        if (id)
            SetisPrintFormOpen(false);
    }
    function CustomOptionsOfStatus({ innerProps, data }) {
        var customDisabledClass = '';
        // var notDisabledOptions = [
        //     WorkorderStatus.Beoordelen__calculeren,
        //     WorkorderStatus.Wachten_op_klant,
        //     WorkorderStatus.Monteur_Uit_te_voeren,
        //     WorkorderStatus.Monteur_Onder_handen,
        //     WorkorderStatus.Monteur_Werk_uitgevoerd,
        //     WorkorderStatus.Offerte_opgevraagd,
        //     WorkorderStatus.Garantie,
        //     WorkorderStatus.Vervallen
        // ];
        // if (notDisabledOptions.includes(data.value)) {
        //     customDisabledClass = 'vn-disabled-option';
        // }
        return (_jsxs("div", { className: `vn-workorderstatus-menu ${customDisabledClass}`, ...innerProps, children: [_jsx("div", { className: 'vn-status-label-text', children: data.label }), _jsx("div", { className: 'vn-status-value', children: data.number }), _jsx("hr", { className: 'vn-status-line' })] }));
    }
    const getPrintFormContent = () => {
        let currentFormType = 'Standard';
        // Check for 'Terplaats' specific fields
        if (formData.tpSameAsClientVisitAddress || formData.tpLocation || formData.tpDate || formData.tpTiming || formData.tpMechanic) {
            currentFormType = 'Terplaats';
            return (_jsx(TerplaatsForm, { onClose: oncloseClicked, formdata: formData, formType: currentFormType, onFieldChange: handleFieldChange, onWorkOrderStatusChange: onWorkOrderStatusChange }));
        }
        // Check for specific keywords in description
        const description = formData.description.toLowerCase();
        if (description.includes('motorreductor')) {
            currentFormType = 'Motorreductor';
            return (_jsx(MotorReductorForm, { onClose: oncloseClicked, formdata: formData, formType: currentFormType, onFieldChange: handleFieldChange, onWorkOrderStatusChange: onWorkOrderStatusChange }));
        }
        else if (description.includes('motor')) {
            currentFormType = 'Motor';
            return (_jsx(MotorForm, { onClose: oncloseClicked, formdata: formData, formType: currentFormType, onFieldChange: handleFieldChange, onWorkOrderStatusChange: onWorkOrderStatusChange }));
        }
        else if (description.includes('pomp')) {
            currentFormType = 'Pomp';
            return (_jsx(PompForm, { onClose: oncloseClicked, formdata: formData, formType: currentFormType, onFieldChange: handleFieldChange, onWorkOrderStatusChange: onWorkOrderStatusChange }));
        }
        else if (description.includes('ventilator')) {
            currentFormType = 'Ventilator';
            return (_jsx(VentilatorForm, { onClose: oncloseClicked, formdata: formData, formType: currentFormType, onFieldChange: handleFieldChange, onWorkOrderStatusChange: onWorkOrderStatusChange }));
        }
        else if (description.includes('seal')) {
            currentFormType = 'Seal';
            return (_jsx(SealForm, { onClose: oncloseClicked, formdata: formData, formType: currentFormType, onFieldChange: handleFieldChange, onWorkOrderStatusChange: onWorkOrderStatusChange }));
        }
        // Default case
        return (_jsx(StandardForm, { onClose: oncloseClicked, formdata: formData, formType: currentFormType, onFieldChange: handleFieldChange, onWorkOrderStatusChange: onWorkOrderStatusChange }));
    };
    const openAddQuotation = () => {
        if (formData.workOrderNumber && formData.id) {
            const workOrderData = {
                label: formData.workOrderNumber,
                value: formData.id
            };
            dispatch(setWorkOrderNumber(workOrderData));
            navigate(`/admin/QuotationTabs`);
        }
    };
    const openAddInvoice = () => {
        if (formData.workOrderNumber && formData.id) {
            const workOrderData = {
                label: formData.workOrderNumber,
                value: formData.id
            };
            dispatch(setInvoiceWorkOrderNumber(workOrderData));
            navigate(`/admin/InvoiceTabs`);
        }
    };
    function getWorkorderStatus(workOrders, WorkCategoryID) {
        const filterAndMapWorkOrders = (filteredWorkOrderStatus) => {
            return workOrders
                ?.filter((option) => !filteredWorkOrderStatus.includes(option.value))
                ?.map((option, index) => {
                let label = option.value === WorkorderStatus.Garantie || option.value === WorkorderStatus.Vervallen
                    ? option.label
                    : `${index + 1}. ${option.label}`;
                return { ...option, label };
            });
        };
        switch (WorkCategoryID) {
            case WorkorderCategory.Werkplaats:
                return filterAndMapWorkOrders([
                    WorkorderStatus.Tweede_meting_inplannen,
                    WorkorderStatus.Monteur_Onder_handen,
                    WorkorderStatus.Monteur_Werk_uitgevoerd,
                    WorkorderStatus.Wachten_op_klant,
                    WorkorderStatus.Deellevering
                ]);
            case WorkorderCategory.Levering:
            case WorkorderCategory.Levering_ipv_reparatie:
                return filterAndMapWorkOrders([
                    WorkorderStatus.Monteur_Diagnose_stellen,
                    WorkorderStatus.Beoordelen__calculeren,
                    WorkorderStatus.Wachten_op_klant,
                    WorkorderStatus.Tweede_meting_inplannen,
                    WorkorderStatus.Monteur_Onder_handen,
                    WorkorderStatus.Monteur_Werk_uitgevoerd,
                    WorkorderStatus.Monteur_Uit_te_voeren
                ]);
            case WorkorderCategory.Projecten:
            case WorkorderCategory.Preventief_onderhoud:
                return filterAndMapWorkOrders([
                    WorkorderStatus.Offerte_opgevraagd,
                    WorkorderStatus.Wachten_op_klant,
                    WorkorderStatus.Tweede_meting_inplannen,
                    WorkorderStatus.Monteur_Onder_handen,
                    WorkorderStatus.Monteur_Werk_uitgevoerd,
                    WorkorderStatus.Deellevering,
                    WorkorderStatus.Gefactureerd
                ]);
            case WorkorderCategory.Inspectie_en_trillingsmetingen:
                return filterAndMapWorkOrders([
                    WorkorderStatus.Offerte_opgevraagd,
                    WorkorderStatus.Wachten_op_klant,
                    WorkorderStatus.Monteur_Onder_handen,
                    WorkorderStatus.Monteur_Werk_uitgevoerd,
                    WorkorderStatus.Deellevering,
                    WorkorderStatus.Vijftig_procent_aanbetaling_verstuurd,
                    WorkorderStatus.Gefactureerd
                ]);
            default:
                return filterAndMapWorkOrders([]);
        }
    }
    const handleWorkOrderDelete = () => {
        if (id) {
            dispatch(deleteWorkOrderByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => navigate('/admin/WorkordersList'))
                .catch((error) => {
                if (error.status == 405) {
                    setWorkOrderDeleteNotificationPopup(true);
                    setWorkOrderDeleteErrorMessage(error.error);
                }
                setWorkOrderDeleteConfirmationPopup(false);
            });
        }
    };
    const onCancelWorkOrderDeleteClicked = () => {
        setWorkOrderDeleteConfirmationPopup(false);
        setWorkOrderDeleteNotificationPopup(false);
    };
    const handleDeliveryNotePrintAndPdfClick = () => {
        if (id)
            dispatch(getWorkOrderByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setFormData({
                    ...formData,
                    deliveryNoteNumber: res.deliveryNoteNumber,
                    statusId: res.statusId
                });
            })
                .catch((error) => {
                console.error('Bad request.');
            });
    };
    const handleDeliveryNotePrintViewClose = () => {
        setIsDeliveryNoteTableOpen(false);
    };
    function onCreateOrders() {
        if (formData.workOrderNumber && formData.id) {
            const workOrderData = {
                label: formData.workOrderNumber,
                value: formData.id
            };
            dispatch(setWorkOrderNumberAtOrder(workOrderData));
            navigate('/admin/OrderTabs');
        }
    }
    /*Copy Workorder data on new tab */
    const onCancelWorkOrderCopyNotification = () => {
        IsCopyPopupOpen(false);
    };
    const onConfirmWorkorderCopyNotification = () => {
        const modifiedFormData = {
            ...formData,
            workOrderFormData: '',
            statusId: WorkorderStatus.Nieuw,
            objectInside: undefined,
            orderDate: undefined,
            technicalCompletionDate: undefined,
            tpDate: undefined,
            tpLocation: undefined,
            tpMechanic: undefined,
            tpSameAsClientVisitAddress: false,
            tpTiming: undefined,
            isCopied: true
        };
        dispatch(createWorkOrderAsync(modifiedFormData))
            .unwrap()
            .then((res) => {
            IsCopyPopupOpen(false);
            setTimeout(() => {
                const newTab = window.open(`/admin/WorkordersTabs/${res.id}`, '_blank');
                if (newTab) {
                    newTab.focus();
                }
            }, 1000);
        });
    };
    useEffect(() => {
        setSavedDebtor(formData.debtorName);
        setSavedDescription(formData.description);
    }, [formData.debtorName, submitWorkOrder]);
    const handleCalculationTableClose = () => {
        setIsCalculationSelectionTableOpen(false);
    };
    // --------------------------Old functionality of facturen aanmaken---------------------
    // const handleMaterialTableClose = () => {
    //     setIsMaterialSelectionTableOpen(false);
    // };
    // const handleSelectedMaterialSubmit = (selectedMaterial: MaterialDto[]) => {
    //     if (formData.workOrderNumber && formData.id) {
    //         const workOrderData: LabelValueDto = {
    //             label: formData.workOrderNumber,
    //             value: formData.id
    //         };
    //         dispatch(setInvoiceWorkOrderNumber(workOrderData));
    //         dispatch(setSelectedWorkorderMaterialItemsList(selectedMaterial));
    //         navigate(`/admin/InvoiceTabs`);
    //     }
    //     setIsMaterialSelectionTableOpen(false);
    // };
    const cleanupForModuleDataSharingLocalStorageEntries = () => {
        const cleanup = () => {
            const now = Date.now();
            Object.keys(localStorage).forEach(key => {
                if (key.startsWith('quotationData_') ||
                    key.startsWith('orderData_') ||
                    key.startsWith('invoiceData_')) {
                    const data = JSON.parse(localStorage.getItem(key));
                    if (now - data.timestamp > 3600000) { // 1 hour expiration
                        localStorage.removeItem(key);
                    }
                }
            });
        };
        // Run cleanup every hour
        const interval = setInterval(cleanup, 3600000);
        return () => clearInterval(interval);
    };
    // const handleSelectedCalculationSubmit = (selectedCalculations: CalculationDto[]) => {
    //     if (formData.workOrderNumber && formData.id) {
    //         const workOrderData: LabelValueDto = {
    //             label: formData.workOrderNumber,
    //             value: formData.id
    //         };
    //         const dataKey = `quotationData_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    //         const dataToSave = {
    //             timestamp: Date.now(),
    //             workOrderData,
    //             selectedCalculations
    //         };
    //         localStorage.setItem(dataKey, JSON.stringify(dataToSave));
    //         // Cleanup old entries
    //         cleanupQuotationDataLocalStorageEntries();
    //         const url = `/admin/QuotationTabs?dataKey=${encodeURIComponent(dataKey)}`;
    //         window.open(url, '_blank');
    //         // dispatch(setWorkOrderNumber(workOrderData));
    //         // dispatch(setSelectedWorkorderCalculationItemsList(selectedCalculations));
    //         // navigate(`/admin/QuotationTabs`);
    //     }
    //     setIsCalculationSelectionTableOpen(false);
    // };
    const handleSelectedCalculationSubmit = (selectedCalculations) => {
        if (formData.workOrderNumber && formData.id) {
            const dataKey = `quotationData_${Date.now()}`;
            const workOrderData = {
                label: formData.workOrderNumber,
                value: formData.id
            };
            const dataToSave = {
                workOrderId: formData.id,
                workOrderNumber: formData.workOrderNumber,
                calculations: selectedCalculations,
                timestamp: Date.now()
            };
            localStorage.setItem(dataKey, JSON.stringify(dataToSave));
            const url = `/admin/QuotationTabs?dataKey=${encodeURIComponent(dataKey)}`;
            window.open(url, '_blank');
        }
        setIsCalculationSelectionTableOpen(false);
    };
    const handleCalculationForOrderTableClose = () => {
        setIsCalculationSelectionForOrderTableOpen(false);
    };
    const cleanupOrderDataLocalStorageEntries = () => {
        const now = Date.now();
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('orderData_')) {
                const data = JSON.parse(localStorage.getItem(key));
                if (now - data.timestamp > 3600000) { // 1 hour
                    localStorage.removeItem(key);
                }
            }
        });
    };
    const handleSelectedCalculationForOrderSubmit = (selectedCalculations) => {
        if (formData.workOrderNumber && formData.id) {
            const workOrderData = {
                label: formData.workOrderNumber,
                value: formData.id
            };
            // Generate unique session-based key
            const dataKey = `orderData_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            // Store data with expiration (1 hour)
            const dataToSave = {
                timestamp: Date.now(),
                workOrderData,
                selectedCalculations
            };
            localStorage.setItem(dataKey, JSON.stringify(dataToSave));
            // Cleanup old entries
            cleanupOrderDataLocalStorageEntries();
            const url = `/admin/OrderTabs?dataKey=${encodeURIComponent(dataKey)}`;
            window.open(url, '_blank');
            // dispatch(setWorkOrderNumberAtOrder(workOrderData));
            // dispatch(setSelectedWorkorderCalculationToOrderItemsList(selectedCalculations));
            // navigate('/admin/OrderTabs');
        }
        setIsCalculationSelectionForOrderTableOpen(false);
    };
    // const handleSelectedCalculationForOrderSubmit = (selectedCalculations: CalculationDto[]) => {
    //     if (formData.workOrderNumber && formData.id) {
    //       const dataKey = `orderData_${Date.now()}`;
    //       const dataToSave = {
    //         workOrderId: formData.id,
    //         workOrderNumber: formData.workOrderNumber,
    //         calculations: selectedCalculations,
    //         timestamp: Date.now()
    //       };
    //       localStorage.setItem(dataKey, JSON.stringify(dataToSave));
    //       const url = `/admin/OrderTabs?dataKey=${encodeURIComponent(dataKey)}`;
    //       window.open(url, '_blank');
    //     }
    //     setIsCalculationSelectionForOrderTableOpen(false);
    //   };
    //-------------------Module Lock Functionality---------------------------
    const checkModulelock = async () => {
        // if (warningMessageRef.current) {
        //     warningMessageRef.current.resetTimer();
        // }
        if (parseInt(id)) {
            dispatch(resetTimer());
            var moduleLockRequestData = {
                moduleId: VisserModule.Werkorder,
                recordId: parseInt(id)
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData))
                    .unwrap()
                    .then();
                if (res.isModuleAlreadyLocked) {
                    // setIsPersistantInfoCustomToasterOpen(true);
                    dispatch(setModuleLock());
                    return true;
                }
                else {
                    dispatch(unsetModuleLock());
                    // setIsPersistantInfoCustomToasterOpen(false);
                    return false;
                }
            }
            catch (error) {
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    useEffect(() => {
        // Cleanup function that runs when the component unmounts
        return () => {
            dispatch(resetTimer());
            dispatch(unsetModuleLock());
            dispatch(clearUpdateModulePermissionStatus());
        };
    }, [resetTimer]);
    useEffect(() => {
        dispatch(unsetModuleLock());
        cleanupForModuleDataSharingLocalStorageEntries();
        // checkModulelock();
    }, []);
    const checkModulelockandTimeTriggerForFields = async () => {
        if (parseInt(id)) {
            dispatch(resetTimer());
            // Return false immediately to allow the user to continue working
            var result = false;
            // Call the debounced API function
            debouncedCheckModuleLockApiCall()
                .then((res) => {
                if (res.isModuleAlreadyLocked) {
                    // Notify the user if the module is locked
                    // setIsPersistantInfoCustomToasterOpen(res.isModuleAlreadyLocked);
                    dispatch(setModuleLock());
                    result = res.isModuleAlreadyLocked;
                }
                else {
                    dispatch(unsetModuleLock());
                    result = res.isModuleAlreadyLocked;
                }
            })
                .catch(() => {
                dispatch(unsetModuleLock());
                // Handle any errors if needed
            });
            return result; // Allow user to continue working immediately
        }
        return false;
    };
    const checkModuleLockApiCall = async () => {
        const moduleLockRequestData = {
            moduleId: VisserModule.Werkorder,
            recordId: formData.id
        };
        return await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData)).unwrap();
    };
    const debouncedCheckModuleLockApiCall = useAsyncDebounce(checkModuleLockApiCall, parseInt(process.env.REACT_APP_DEBOUNCE_TIME_FOR_MODULE_LOCK_API));
    const handleHoursAndMaterialsTabBold = (state) => {
        setIsHoursAndMaterialTabBold(state);
    };
    const handleCalculationTabBold = (state) => {
        setIsCalculationTabBold(state);
    };
    const handleOrderTabBold = (state) => {
        setIsOrderTabBold(state);
    };
    const handleAttachmentTabBold = (state) => {
        setIsAttachmentTabBold(state);
    };
    // const handleCreateInvoiceButtonClick = () => {
    //     if (formData.workOrderQuotation && formData.workOrderQuotation.length > 0) {
    //         if (formData.workOrderNumber && formData.id) {
    //             const workOrderData: LabelValueDto = {
    //                 label: formData.workOrderNumber,
    //                 value: formData.id
    //             };
    //             dispatch(setInvoiceWorkOrderNumber(workOrderData));
    //         }
    //         const latestQuotationId = formData.workOrderQuotation.slice().sort((a, b) => b.id - a.id)[0].id;
    //         const latestQuotationNotes = formData.workOrderQuotation.slice().sort((a, b) => b.id - a.id)[0].note;
    //         dispatch(setInvoiceNotes(latestQuotationNotes));
    //         dispatch(getAllQuotationAmountsAsync(latestQuotationId))
    //             .unwrap()
    //             .then((res) => {
    //                 dispatch(setSelectedQuotationItemsListForInvoice(res));
    //             });
    //         navigate(`/admin/InvoiceTabs`);
    //     } else {
    //         dispatch(addErrorNotification('De laatste offerte voor de werkorder bestaat niet'));
    //     }
    // };
    const handleCreateInvoiceButtonClick = () => {
        if (formData.workOrderQuotation && formData.workOrderQuotation.length > 0) {
            const dataKey = `invoiceData_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            if (formData.workOrderNumber && formData.id) {
                const workOrderData = {
                    label: formData.workOrderNumber,
                    value: formData.id
                };
                const latestQuotation = formData.workOrderQuotation.slice().sort((a, b) => b.id - a.id)[0];
                const latestQuotationId = latestQuotation.id;
                const latestQuotationNotes = latestQuotation.note;
                // Store data in localStorage
                const invoiceData = {
                    workOrderData,
                    quotationNotes: latestQuotationNotes,
                    timestamp: Date.now()
                };
                localStorage.setItem(dataKey, JSON.stringify(invoiceData));
                dispatch(getAllQuotationAmountsAsync(latestQuotationId))
                    .unwrap()
                    .then((res) => {
                    // Update stored data with amounts
                    const updatedData = {
                        ...invoiceData,
                        quotationAmounts: res
                    };
                    localStorage.setItem(dataKey, JSON.stringify(updatedData));
                    const url = `/admin/InvoiceTabs?dataKey=${encodeURIComponent(dataKey)}`;
                    window.open(url, '_blank');
                })
                    .catch((error) => {
                    localStorage.removeItem(dataKey);
                    dispatch(addErrorNotification('Fout bij ophalen offertebedragen'));
                });
            }
        }
        else {
            dispatch(addErrorNotification('De laatste offerte voor de werkorder bestaat niet'));
        }
    };
    const onConfirmQuotationWarningNotification = () => {
        setIsCalculationSelectionTableOpen(true);
        setIsQuotationWarningMessagePopupOpen(false);
    };
    const onCancelQuotationWarningNotification = () => {
        setIsQuotationWarningMessagePopupOpen(false);
    };
    const handleWorkOrderOnModuleLockReset = (value) => {
        if (value) {
            const triggeredErrors = validateForm();
            if (Object.values(triggeredErrors).every((error) => error === '' || error?.length === 0)) {
                dispatch(updateWorkOrderAsync(formData));
            }
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { children: _jsxs(Form, { onSubmit: handleSubmit, children: [_jsxs("div", { className: 'vn-Workorder-Titlebar', children: [_jsxs("div", { className: 'ml-1 mb-1', children: [_jsx("h4", { className: 'vn-Workorder-Title', children: "Werkorders" }), _jsxs(Breadcrumb, { children: [_jsxs(Breadcrumb.Item, { href: '/admin/WorkordersList', children: [_jsx("span", { children: _jsx(IonIcon, { icon: receiptOutline, className: 'vn-breadcrum-icon' }) }), "Werkorders"] }), _jsx(Breadcrumb.Item, { active: true, className: 'breadcrumb-active', children: formData.workOrderNumber }), formData.id ? (_jsxs(_Fragment, { children: [_jsx(Breadcrumb.Item, { active: true, className: 'breadcrumb-active', children: savedDebtor }), _jsx(Breadcrumb.Item, { active: true, className: 'breadcrumb-active', children: savedDescription })] })) : ('')] })] }), _jsxs("div", { className: 'vn-ButtonContainer', children: [_jsx(VnButton, { icon: printOutline, customClassName: 'vn-action-button-cancel', mode: 'secondary', size: 'sm', isDisabled: moduleLocked || !id, customIconClassName: 'vn-action-button-cancel-icon', onClick: async () => {
                                                // handleDymoLabelImagePreview();
                                                handlePrintNode();
                                            }, type: 'button' }), _jsx(VnButton, { icon: trashOutline, customClassName: 'vn-action-button', mode: 'danger', size: 'sm', isDisabled: moduleLocked ||
                                                (handleRolePermission(Permission.WERKORDER, PermissionType.Delete) && id && !disableWorkOrder
                                                    ? false
                                                    : true), customIconClassName: 'vn-action-button-icon', onClick: async () => {
                                                var moduleLockStatus = await checkModulelock();
                                                if (moduleLockStatus == false) {
                                                    setWorkOrderDeleteConfirmationPopup(true);
                                                }
                                            }, type: 'button' }), _jsx(VnButton, { isDisabled: moduleLocked || (handleRolePermission(Permission.WERKORDER, PermissionType.Create) && id ? false : true), icon: copyOutline, customClassName: 'vn-action-button-cancel', mode: 'secondary', size: 'sm', customIconClassName: 'vn-action-button-cancel-icon', onClick: () => IsCopyPopupOpen(true), type: 'button' }), formData.id ? (_jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button', mode: 'primary', size: 'sm', onClick: async () => {
                                                setSubmitWorkOrder(true);
                                            }, type: 'submit', customIconClassName: 'vn-action-button-icon', isDisabled: moduleLocked ||
                                                (handleRolePermission(Permission.WERKORDER, PermissionType.Update) && !disableWorkOrder
                                                    ? false
                                                    : true) })) : (_jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button', mode: 'primary', size: 'sm', onClick: () => {
                                                setSubmitWorkOrder(true);
                                            }, type: 'submit', customIconClassName: 'vn-action-button-icon', isDisabled: moduleLocked ||
                                                (handleRolePermission(Permission.WERKORDER, PermissionType.Create) && !disableWorkOrder
                                                    ? false
                                                    : true) }))] })] }), _jsxs("div", { className: 'row', children: [_jsxs("div", { className: 'col-sm-8 vn-workorder-status-container', children: [_jsx(VnButton, { customClassName: 'vn-header-buttons ml-1 vn-workorder-topbar-button', icon: bagHandleOutline, mode: 'primary', type: 'button', 
                                            // onClick={onCreateOrders}
                                            onClick: async () => {
                                                var moduleLockStatus = await checkModulelock();
                                                if (moduleLockStatus == false) {
                                                    setIsCalculationSelectionForOrderTableOpen(true);
                                                }
                                            }, isDisabled: handleRolePermission(Permission.BESTELLINGEN, PermissionType.Create) &&
                                                formData.id &&
                                                formData.workOrderNumber &&
                                                !disableWorkOrder
                                                ? false
                                                : true, children: _jsx("span", { className: 'vn-truncate-text', children: "Bestelling aanmaken" }) }), _jsx(VnButton, { customClassName: 'vn-header-buttons ml-1 vn-workorder-topbar-button', icon: printOutline, mode: 'primary', type: 'button', isDisabled: handleRolePermission(Permission.WERKORDER, PermissionType.Create) &&
                                                formData.id &&
                                                formData.workOrderNumber &&
                                                !disableWorkOrder
                                                ? false
                                                : true, onClick: async () => {
                                                var moduleLockStatus = await checkModulelock();
                                                if (moduleLockStatus == false) {
                                                    setIsDeliveryNoteTableOpen(true);
                                                }
                                            }, children: _jsx("span", { className: 'vn-truncate-text', children: "Afleverbon" }) }), _jsx(VnButton, { customClassName: 'vn-header-buttons ml-1 vn-workorder-topbar-button', icon: add, mode: 'primary', type: 'button', isDisabled: handleRolePermission(Permission.FACTUREN, PermissionType.Create) &&
                                                formData.id &&
                                                formData.workOrderNumber &&
                                                !disableWorkOrder
                                                ? false
                                                : true, 
                                            // onClick={() => openAddInvoice()}
                                            onClick: async () => {
                                                var moduleLockStatus = await checkModulelock();
                                                if (moduleLockStatus == false) {
                                                    //setIsMaterialSelectionTableOpen(true);
                                                    handleCreateInvoiceButtonClick();
                                                }
                                            }, children: _jsx("span", { className: 'vn-truncate-text', children: "Facturen aanmaken" }) }), _jsx(VnButton, { customClassName: 'vn-header-buttons ml-1 vn-workorder-topbar-button', icon: add, mode: 'primary', type: 'button', isDisabled: handleRolePermission(Permission.OFFERTE, PermissionType.Create) &&
                                                formData.id &&
                                                formData.workOrderNumber &&
                                                !disableWorkOrder
                                                ? false
                                                : true, 
                                            // onClick={() => openAddQuotation()}
                                            onClick: async () => {
                                                var moduleLockStatus = await checkModulelock();
                                                if (moduleLockStatus == false && formData.workOrderQuotation) {
                                                    formData.workOrderQuotation?.length > 0
                                                        ? setIsQuotationWarningMessagePopupOpen(true)
                                                        : setIsCalculationSelectionTableOpen(true);
                                                }
                                            }, children: _jsx("span", { className: 'vn-truncate-text', children: "Offerte aanmaken" }) }), _jsx(VnButton, { customClassName: 'vn-header-buttons ml-1 vn-workorder-topbar-button', icon: printOutline, mode: 'primary', type: 'button', isDisabled: handleRolePermission(Permission.WERKORDER, PermissionType.Create) &&
                                                formData.id &&
                                                formData.workOrderNumber &&
                                                !disableWorkOrder
                                                ? false
                                                : true, onClick: async () => {
                                                checkModulelock();
                                                SetisPrintFormOpen(true);
                                            }, children: _jsx("span", { className: 'vn-truncate-text', children: "Werkbon" }) })] }), _jsx("div", { className: 'col-sm-4 vn-status-col', style: { display: 'flex', justifyContent: 'end', flexWrap: 'wrap' }, children: _jsxs("div", { style: { display: 'flex' }, children: [_jsx("label", { className: 'vn-status-label', children: "Status:" }), _jsx(Select, { isSearchable: false, options: getWorkorderStatus(workOrderStatusDropdown, formData.workCategoryId), components: { Option: CustomOptionsOfStatus }, styles: statusDropDownStyles, value: workOrderStatusDropdown?.find((option) => option.value === formData.statusId), onChange: handleStatusDropdownChange, isDisabled: !disableWorkOrder ? false : true, placeholder: 'Selecteer...' })] }) })] }), _jsxs(Tabs, { activeKey: activeTab, onSelect: handleTabChange, className: 'vn-TabHeader', children: [_jsx(Tab, { eventKey: 'InfoTab', title: TabNotification('Info', infoTabErrorBorderColor, isInfoTabUnsaved), tabClassName: `
                                ${infoTabErrorBorderColor ? 'has-errors' : ''} 
                                ${isInfoTabBold ? 'has-data' : ''}
                              `, children: _jsx(InfoTab, { formData: formData, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onToggelButtonChange: handleToggelButtonChangeWrapper, onCalendarChangeWrapper: handleCalendarChangeWrapper, onCalendarChange: handleCalendarChange, onTimeCalenderChange: handleTimeCalendarChangeWrapper, onContactsUpdate: handleContactUpdate }) }), _jsx(Tab, { eventKey: 'GeneralTab', title: TabNotification('Algemeen', generalTabErrorBorderColor, isGeneralTabUnsaved), tabClassName: `${generalTabErrorBorderColor ? 'has-errors' : ''}
                            ${isGeneralTabBold ? 'has-data' : ''}
                            `, children: _jsx(GeneralTab, { formData: formData, errors: errors, onFieldChangeWithoutLockModule: handleFieldChange, onFieldChange: handleFieldChangeWrapperForText, onToggelButtonChange: handleToggelButtonChangeWrapper, onCalendarChange: handleCalendarChangeWrapper, onTimeCalenderChange: handleTimeCalendarChangeWrapper, onContactsUpdate: handleContactUpdateWrapper, disableWorkOrder: disableWorkOrder }) }), _jsx(Tab, { eventKey: 'TechnicalDataTab', title: TabNotification('Technische gegevens', technicalTabErrorBorderColor, isTechnicalTabUnsaved), tabClassName: `${technicalTabErrorBorderColor ? 'has-errors' : ''}
                             ${isTechnicalDataTabBold ? 'has-data' : ''}
                            `, children: _jsx(TechnicalDataTab, { formData: formData, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onToggelButtonChange: handleToggelButtonChangeWrapper, onCalendarChange: handleCalendarChangeWrapper, onTimeCalenderChange: handleTimeCalendarChangeWrapper, onContactsUpdate: handleContactUpdate }) }), _jsx(Tab, { eventKey: 'HoursandMaterialsForm', title: 'Uren en Materialen', tabClassName: `${isHoursAndMaterialTabBold ? 'has-data' : ''}
                            `, disabled: id === undefined || !handleRolePermission(Permission.URENENMATERIALEN, PermissionType.Read), children: _jsx(HoursandMaterialsTab, { formData: formData, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onToggelButtonChange: handleToggelButtonChangeWrapper, onCalendarChange: handleCalendarChangeWrapper, onTimeCalenderChange: handleTimeCalendarChangeWrapper, onContactsUpdate: handleContactUpdate, disableWorkOrder: disableWorkOrder, isHoursAndMaterialTabBold: handleHoursAndMaterialsTabBold }) }), _jsx(Tab, { eventKey: 'CalculationTab', title: 'Calculatie', tabClassName: `${isCalculationTabBold ? 'has-data' : ''}
                            `, disabled: id === undefined || !handleRolePermission(Permission.CALCULATIE, PermissionType.Read), children: _jsx(CalculationTab, { formData: formData, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onToggelButtonChange: handleToggelButtonChangeWrapper, onCalendarChange: handleCalendarChangeWrapper, onTimeCalenderChange: handleTimeCalendarChangeWrapper, onContactsUpdate: handleContactUpdate, disableWorkOrder: disableWorkOrder, isCalculationTabBold: handleCalculationTabBold }) }), _jsx(Tab, { eventKey: 'OrdersTab', title: 'Bestellingen', tabClassName: `${isOrderTabBold ? 'has-data' : ''}
                            `, disabled: id === undefined || !handleRolePermission(Permission.WBESTELLINGEN, PermissionType.Read), children: _jsx(OrdersTab, { formData: formData, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onToggelButtonChange: handleToggelButtonChangeWrapper, onCalendarChange: handleCalendarChangeWrapper, onTimeCalenderChange: handleTimeCalendarChangeWrapper, onContactsUpdate: handleContactUpdate, isOrderTabBold: handleOrderTabBold }) }), _jsx(Tab, { eventKey: 'NotesTab', title: TabNotification('Notities', false, isNotitiesTabUnsaved), tabClassName: `${isNotesTabBold ? 'has-data' : ''}`, children: _jsx(NotesTab, { formData: formData, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onToggelButtonChange: handleToggelButtonChangeWrapper, onCalendarChange: handleCalendarChangeWrapper, onTimeCalenderChange: handleTimeCalendarChangeWrapper, onContactsUpdate: handleContactUpdate, disableWorkOrder: disableWorkOrder }) }), _jsx(Tab, { eventKey: 'AttachmentsTab', title: 'Bijlagen', tabClassName: `${isAttachmentTabBold ? 'has-data' : ''}
                            `, disabled: id === undefined || !handleRolePermission(Permission.WBIJLAGEN, PermissionType.Read), children: _jsx(AttachmentsTab, { formData: formData, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onToggelButtonChange: handleToggelButtonChangeWrapper, onCalendarChange: handleCalendarChangeWrapper, onTimeCalenderChange: handleTimeCalendarChangeWrapper, onContactsUpdate: handleContactUpdate, disableWorkOrder: disableWorkOrder, isAttachmentTabBold: handleAttachmentTabBold }) })] })] }) }), _jsx(ModalPopup, { title: 'Werkbon', content: getPrintFormContent(), onOpen: isPrintFormOpen, onClose: () => SetisPrintFormOpen(false), modalWidth: 'xl' }), _jsx(VnConfirmationModel, { title: 'Alle tabbladgegevens van de werkorder worden permanent verwijderd. Weet u zeker dat u de werkorder wilt verwijderen?', onCancel: () => onCancelWorkOrderDeleteClicked(), onConfirm: () => handleWorkOrderDelete(), onOpen: isWorkOrderDeleteConfirmationPopup }), _jsx(VnNotificationModel, { message: workOrderDeleteErrorMessage, onConfirm: () => onCancelWorkOrderDeleteClicked(), onOpen: isWorkOrderDeleteNotificationPopup }), _jsx(VnNotificationModel, { message: 'Bent u zeker dat u wilt doorgaan met het maken van een nieuwe werkorder met gekopieerde informatie?', onCancel: () => onCancelWorkOrderCopyNotification(), onConfirm: () => onConfirmWorkorderCopyNotification(), onOpen: copyPopupOpen, onCancelShow: true }), _jsx(ModalPopup, { title: 'Selecteer Uren en Materialen', content: _jsx(DeliveryNoteHoursAndMaterialTable, { onClose: handleDeliveryNotePrintViewClose, workOrderData: deliveryNoteWorkOrderData, onDeliveryNotePrintAndPdfClick: handleDeliveryNotePrintAndPdfClick }), onOpen: isDeliveryNoteTableOpen, onClose: () => setIsDeliveryNoteTableOpen(false), modalWidth: 'xl' }), _jsx(ModalPopup, { title: 'Selecteer Regels', content: _jsx(CalculationSelectionTable, { onClose: handleCalculationTableClose, handleSelectedCalculationSubmit: handleSelectedCalculationSubmit }), onOpen: isCalculationSelectionTableOpen, onClose: () => setIsCalculationSelectionTableOpen(false), modalWidth: 'xl' }), _jsx(ModalPopup, { title: 'Selecteer Regels', content: _jsx(CalculationSelectionForOrderTable, { onClose: handleCalculationForOrderTableClose, handleSelectedCalculationSubmit: handleSelectedCalculationForOrderSubmit }), onOpen: isCalculationSelectionForOrderTableOpen, onClose: () => setIsCalculationSelectionForOrderTableOpen(false), modalWidth: 'xl' }), updateModulePermissionStatus && !moduleLocked ? (_jsx(PersistentWarningMessage, { recordId: formData.id, moduleId: VisserModule.Werkorder, handleIsModuleLockReset: handleWorkOrderOnModuleLockReset })) : (''), moduleLocked ? _jsx(PersistentInfoMessage, { recordId: formData.id, moduleId: VisserModule.Werkorder }) : '', _jsx(ModalPopup, { title: 'Werkorder Label', content: _jsx(WorkorderLabelPreview, { onClose: () => setIsWorkOrderPrintPreviewPopupOpen(false), workOrder: formData }), onOpen: isWorkOrderPrintPreviewPopupOpen, onClose: () => setIsWorkOrderPrintPreviewPopupOpen(false), modalWidth: 'lg' }), _jsx(VnNotificationModel, { message: `Er zijn bestaande offertes:\n${formData.workOrderQuotation && formData.workOrderQuotation.map((q) => q.quotationNumber.replace(/@@/g, '')).join('\n')}\nWeet u zeker dat u voor dezelfde werkorder aanvullende offertes wilt aanmaken?`, onCancel: () => onCancelQuotationWarningNotification(), onConfirm: () => onConfirmQuotationWarningNotification(), onOpen: isQuotationWarningMessagePopupOpen, onCancelShow: true })] }));
};
export default WorkorderView;
